import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { userFlagPin, userUnFlagPin, clearPin } from "../../../actions/pins";
import { userFlagComment } from "../../../actions/auth";
const useFlagForm = () => {
  const [flagModalState, setflagModalState] = useState(false);
  const [flagCommentModalState, setflagCommentModalState] = useState(false);
  const [flagForm, setflagForm] = useState({ reportType: "", reason: "" });
  const [flagFormError, setFlagFormError] = useState("");
  const auth = useSelector((state) => state.auth);
  const { user } = auth;
  const dispatch = useDispatch();
  const history = useHistory();
  const flagToggle = (pin) => {
    setflagModalState(!flagModalState);
    setFlagFormError("");
    const flagid = pin.userFlaggedBefore
      ? pin.flaggerstory.filter((a) => a.flagger === user.id)[0].id
      : null;
    setflagForm({
      pinId: pin.id,
      flagger: user.id,
      flagged: pin.userFlaggedBefore ? false : true,
      flagId: flagid,
      reportType: "",
      reason: "",
    });
  };
  const flagCommentToggle = (id) => {
    setflagCommentModalState(!flagCommentModalState);
    setFlagFormError("");
    setflagForm({
      comment: id,
      flagger: user.id,
      flagged: true,
      reportType: "",
      reason: "",
    });
  };
  const handleFlagFormChange = (e) => {
    e.persist();
    if (flagFormError) {
      setFlagFormError("");
    }
    setflagForm((flagForm) => ({
      ...flagForm,
      [e.target.name]: e.target.value,
    }));
  };

  const hasRequiredFlagFields = () => {
    const reportType = String(flagForm.reportType || "").trim();
    const reason = String(flagForm.reason || "").trim();
    return Boolean(reportType) && Boolean(reason);
  };

  const onFlagSubmit = (e) => {
    e.preventDefault();
    console.log('onFlagSubmit called, flagForm:', flagForm);
    if (flagForm.flagged === false) {
      // Unflagging
      console.log('Unflagging pin with flagId:', flagForm.flagId);
      dispatch(userUnFlagPin(flagForm.flagId, true))
        .then((res) => {
          console.log('Unflag promise resolved');
          setflagModalState(!flagModalState);
          dispatch(clearPin());
          history.push("/");
        })
        .catch((err) => {
          console.error('Unflag error:', err);
          setflagModalState(!flagModalState);
        });
    } else {
      // Flagging
      if (!hasRequiredFlagFields()) {
        setFlagFormError("Please select a report type and provide a reason before submitting.");
        return;
      }
      console.log('Flagging pin');
      dispatch(
        userFlagPin({
          ...flagForm,
          reason: String(flagForm.reason).trim(),
        }))
        .then((res) => {
          console.log('Flag promise resolved');
          setflagModalState(!flagModalState);
          dispatch(clearPin());
          history.push("/");
        })
        .catch((err) => {
          console.error('Flag error:', err);
          setflagModalState(!flagModalState);
        });
      setFlagFormError("");
    }
  };
  const onFlagCommentSubmit = (e) => {
    e.preventDefault();
    if (!hasRequiredFlagFields()) {
      setFlagFormError("Please select a report type and provide a reason before submitting.");
      return;
    }
    dispatch(
      userFlagComment({
        ...flagForm,
        reason: String(flagForm.reason).trim(),
      })
    );
    setFlagFormError("");
    setflagCommentModalState(!flagCommentModalState);
  };
  return {
    flagForm,
    flagFormError,
    flagToggle,
    flagCommentToggle,
    flagCommentModalState,
    flagModalState,
    onFlagSubmit,
    onFlagCommentSubmit,
    handleFlagFormChange,
  };
};

export default useFlagForm;
